module.exports = __webpack_public_path__ + "static/media/Member-Icon.b05e5f22.png";